export const Email = async(value) => {
    const emailRgx = /^.*@{1}.*\.{1}.*/;
    return emailRgx.test(value);
}

export const Uniques = async(collection = [], key = '') => {

    var result = [];
    var base = [];

    collection.forEach(x => {
        base.push(x[key]);
    });

    result = [...new Set(base)];

    return result;
}

export const ScapingRegex = (input) => {
    var result = input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return result;
}

export const Dates = (input=new Date()) => {
    const month = input.getMonth() + 1;
    const day = input.getDate();
    var result=`${input.getFullYear()}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    return result;
}

export const IsZip = async(input) => {
    const zipRgx = /.*\.zip/;
    return zipRgx.test(input);
}

export const CorrectZipName = async(input) => {
    const sanitazion = input.replaceAll(" ","");
    const nameRgx = /[0-9]+-[A-Z0-9]{5}\.zip/;
    return nameRgx.test(sanitazion);
}

export const InstanceCounter = async(collection, key, input) => {
    var result = [];

    collection.forEach((x,i) => {
        const value =  x[key];
        if(value === input){
            result.push({
                index: i,
                value: x
            });
        }
    });

    return result;
}

export const IsVoid = async(input) => {
    var result = false;
    
    const voidness = [undefined, null, '', [], {}];

    voidness.forEach(x => {
        if(input === x){
            result = true
        }
    });

    return result;
}

export const HigherDate = async(dates) => {
    var converted = dates.map(x => new Date(x));
    const latestDate = new Date(Math.max(...converted.map(d => d.getTime()))).toLocaleDateString('en-US');
    return latestDate;
}

export const HasErrorStatus = async(parts) => {
    var result = false;
    parts.forEach(x => {
        if(!result){
            result = x.status.includes("Error");
        }
    });
    return result;
}

//region LeastPartStatus
export const LeastPartStatus = async(parts) => {
    var status = Infinity;
    var statusString = '';

    for(let i = 0; i < parts.length ; i++){
        if(parts[i].status_id < status){
            status = parts[i].status_id;
            statusString = parts[i].status;
        }
    }

    const result = {
        id: status,
        status: statusString
    };

    return result;
}

//region HighestPartStatus
export const HighestPartStatus = async(parts) => {
    var status = 0;
    var statusString = '';

    for(let i = 0; i < parts.length ; i++){
        if(parts[i].status_id > status){
            status = parts[i].status_id;
            statusString = parts[i].status;
        }
    }

    const result = {
        id: status,
        status: statusString
    };

    return result;
}

//region HasReprintedParts
export const HasReprintedParts = async(parts) => {
    var result = false

    for(let i = 0; i < parts.length ; i++){
        let info = parts[i].logs;
        for (let l = 0; l < info.length; l++)
        {
            if(info[l].data.title === 'Reprint'){
                result = true;
                break;
            }
        }
    }

    return result;
}